import { STATISTIC_TYPE } from "types/ReportingDashboard/elements.types"
import { DEFAULT_HEADERS, DEFAULT_CHART_LABELS, TOTALS_KEY } from "constants/tableConversion"
import {
  RawInputData,
  TransformedTableData,
  PieChartSlice,
} from "types/tableConversion.types"
import { isStatisticType } from "../tableConversionHelpers"

/**
 * Converts XTAB_SIMPLE (single column totals) data to chart format
 */
export const convertXTABSimpleToChart = (data: RawInputData): TransformedTableData => {
  const dataRows = data.data.slice(1)
  
  // Determine the statistic type from the first data row
  let detectedStatType = STATISTIC_TYPE.N
  if (dataRows.length > 0 && dataRows[0][1]) {
    detectedStatType = isStatisticType(dataRows[0][1])
      ? (dataRows[0][1] as STATISTIC_TYPE)
      : STATISTIC_TYPE.N
  }

  const thirdHeader = data.data[0][2] || DEFAULT_HEADERS.VALUES

  const transformedData: TransformedTableData = {
    headers: [
      { header: DEFAULT_HEADERS.CATEGORY, subHeaders: [] },
      { header: DEFAULT_HEADERS.STATISTIC, subHeaders: [] },
      { header: String(thirdHeader), subHeaders: [] },
    ],
    rows: [],
    hasSubHeaders: false,
    barChartData: {
      keys: [DEFAULT_HEADERS.VALUES],
      data: [],
      xAxisLabel: DEFAULT_CHART_LABELS.CATEGORIES,
      statisticTypes: [detectedStatType],
    },
    pieChartData: {
      categoryData: [],
      subCategoryData: [],
      statisticTypes: [detectedStatType],
    },
  }

  dataRows.forEach(row => {
    const category = row[0]
    const statisticType = row[1]
    const value = parseFloat(String(row[2])) || 0

    if (category && statisticType) {
      const statType = isStatisticType(statisticType)
        ? (statisticType as STATISTIC_TYPE)
        : STATISTIC_TYPE.N

      transformedData.rows.push([category, statType, value])

      // Exclude "Totals" row from chart data
      if (category !== TOTALS_KEY) {
        transformedData.barChartData.data.push({
          xValue: category,
          [DEFAULT_HEADERS.VALUES]: {
            [statType]: value,
          },
        })
      }
    }
  })

  // Sort bar chart data by category name
  transformedData.barChartData.data.sort((a, b) => {
    return String(a.xValue).localeCompare(String(b.xValue))
  })

  // Create pie chart data from categories (excluding Totals)
  const pieSlices: PieChartSlice[] = transformedData.barChartData.data.map(
    item => ({
      id: item.xValue,
      label: item.xValue,
      value: (item[DEFAULT_HEADERS.VALUES] as { [key: string]: number })[detectedStatType] || 0,
    })
  )

  transformedData.pieChartData.categoryData = [
    {
      statistic: detectedStatType,
      data: pieSlices,
    },
  ]

  return transformedData
}